/**
 * Created by adam on 2020-07-13.
 */


module.exports = {

    /**
     * whether the user should be
     * able to click on things which only
     * admins can click, etc
     *
     * No actual security should hang on this,
     * just interface management
     */
    isAdmin : false
};

